// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240134/js/" + chunkId + "." + {"44":"1fe9ceac","225":"a03ddb83","481":"63776a4c","486":"de584e9c","770":"9c880f49"}[chunkId] + ".0.5073154091231424.chunk.js";
};